import { Navigate, Outlet } from 'react-router-dom'
import {isUserLoggedIn, getUserType } from '../config/userSession';

const ProtectedTenantRoutes = () => {
return (
    isUserLoggedIn() && getUserType() === 'Tenant' ? <Outlet/> : <Navigate to='/login'/>
  )
}

export default ProtectedTenantRoutes;